/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown>, registry: NonNullable<unknown> }} Tld_Pricing_Registry_SavedInputs */

const id_tld_pricing_registry_saved = /** @type {(inputs: Tld_Pricing_Registry_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registrasi otomatis ${i?.tld} diubah ke ${i?.registry}.`)
};

const en_tld_pricing_registry_saved = /** @type {(inputs: Tld_Pricing_Registry_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} now registers through ${i?.registry}.`)
};

/**
* | output |
* | --- |
* | "{tld} now registers through {registry}." |
*
* @param {Tld_Pricing_Registry_SavedInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_registry_saved = /** @type {((inputs: Tld_Pricing_Registry_SavedInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Registry_SavedInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_registry_saved(inputs)
	return id_tld_pricing_registry_saved(inputs)
});